export default __webpack_public_path__ + "static/waitingThoughtWalking-61c34a2e5d9db5f38d88edf9b1eb9989.svg";